import React from "react";
import { GlossyThemeProvider } from "@glossy";
import {
  Preflight,
  ThemeProvider as XThemeProvider,
  defaultTheme,
} from "@xstyled/styled-components";
import Banners from "@radarly/app/containers/banners";
import Main from "@radarly/components/pages/main";
import PanelProvider from "@radarly/core/panel/store";
import { useCurrentProject } from "@radarly/core/project/use-cases";
import { NavigationNavbar } from "@radarly/shared/navigation/navbar";
import Switcher from "@radarly/shared/navigation/switcher";
import Panel from "@radarly/shared/panel";
import CardEdition from "@radarly/shared/panels/card-edition";
import DiscoveryDetailsPanel from "@radarly/shared/panels/discovery-details";
import ImageClusterPanel from "@radarly/shared/panels/image-cluster";
import PostsPanel from "@radarly/shared/panels/posts";
import TemplateLibrary from "@radarly/shared/panels/wizard/template-library";
import Profile from "@radarly/shared/profile";
import { IRouterService } from "@radarly/shared/router";

const RadarlyPagesMain: React.FC<{ router: IRouterService }> = ({
  children,
  router,
}) => {
  const [panel, setPanel] = React.useState("");
  const closePanel = () => setPanel("");
  const project = useCurrentProject();
  return (
    <XThemeProvider theme={{ ...defaultTheme }}>
      <Preflight />
      <GlossyThemeProvider name="body">
        <PanelProvider>
          <Banners />
          <Main
            navbar={
              <NavigationNavbar
                onOpenPanel={setPanel}
                router={router}
                hideFeatures
              />
            }
            panel={
              panel === "profile" ? (
                <Profile onClose={closePanel} />
              ) : (
                <Panel>
                  {(panel) => (
                    <>
                      {panel.type === "switcher" && (
                        <Switcher router={router} />
                      )}
                      {panel.type === "posts" && <PostsPanel panel={panel} />}
                      {panel.type === "card-edition" && (
                        <CardEdition panel={panel} />
                      )}
                      {panel.type === "template-library" && (
                        <TemplateLibrary
                          router={router}
                          workspaceId={panel.workspaceId}
                        />
                      )}
                      {panel.type === "image-cluster" && (
                        <ImageClusterPanel
                          clusters={panel.clusters}
                          clusterKey={panel.key}
                          onClose={panel.onClose}
                          project={project}
                        />
                      )}
                      {panel.type === "discovery-details" && (
                        <DiscoveryDetailsPanel
                          meta={panel.meta}
                          detailsTemplate={panel.detailsTemplate}
                        />
                      )}
                    </>
                  )}
                </Panel>
              )
            }
          >
            {children}
          </Main>
        </PanelProvider>
      </GlossyThemeProvider>
    </XThemeProvider>
  );
};

export default RadarlyPagesMain;
